import React, {useEffect} from 'react';
import Chat from './Chat';
import Laptop from './img/laptop.svg';
import DevBox from './Components/DevBox';
import DevInfo from './Components/DevInfo';
import InfoImg from './img/website-info.png';
import InfoImg1 from './img/webstack.svg';
import Aos from 'aos';
import "aos/dist/aos.css";

function Websites() {
    
       
    useEffect(() => {
        Aos.init({ duration: 700,
            delay:200});
    }, [])

    return (
        <div className="websites">
            <div className="website-hero-bg"/>      
            <div className="website-hero-white"/>      
            <div className="website-hero" data-aos="fade-up" style={{overflowX: 'hidden'}}>
                <div className="website-hero-text">
                    <h1>WEBSITE</h1>
                    <h1>DEVELOPMENT</h1>
                </div>
                <img src={Laptop}/>
            </div>
            
            
            <div className="website-benifits">
                <DevBox title="Qaulity Guarentee" text="We're that confident that you'll be happy with our work."/>
                <DevBox title="5% Late Penalty" text="We will credit you 5% off orders that go over schedule."/>
                <DevBox title="1 Year Support" text="Hopefully you won't need us, however if you do we're here."/>
            </div>

            <div className="website-info">

                <DevInfo direction="devinfo-left"
                 img={InfoImg} SCALABLE
                 title="RESPONSIVE & ANIMATED"
                 text="Not only will your website be beautiful on a desktop, but it will be responsive to whatever device your consumers access it on. This combined will high-speed and seemless animations leads to a positive customer experience and a desire to descover more about your brand." />

                <DevInfo direction="devinfo-right"
                 img={InfoImg1}
                title="MODERN SOFTWARE STACK"
                 text="We always try to use modern development technologies for our websites to ensure that you benifit from the rapidly moving software industry. Our websites are built with modern technologies to ensure main priciples: Rapid client-side rendering and efficient backend architecture. These principles are implemented with the aim to seperate you from competitors and provide a unique customer experience." />
            </div>
            
            
            <Chat/>
        </div>
    )
}

export default Websites
